module.exports = __webpack_public_path__ + "img/inquiry-bg.8b77e9d1.jpg";